var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"footer_container"},[_c('div',{staticClass:"others_info"},[_vm._v(" "+_vm._s(_vm.footerText)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }